var render = function render(){var _vm=this,_c=_vm._self._c;return (!!_vm.showFigures)?_c('div',[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('app-user-figures-general',{attrs:{"figures":_vm.figures}})],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('app-user-figures-period',{attrs:{"figures":_vm.figures}})],1)],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }